module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/founder/1-ipad-b5439212d1b0ce2762b6117a361b22f9.jpg";